import { Switch } from "@/components/ui/switch";

export function PrivacyPreferencesFields({
  analyticsEnabled,
  onAnalyticsChange,
}) {
  return (
    <div className="space-y-4" data-testid="privacy-preferences-fields">
      <div className="flex items-start justify-between gap-4 rounded-xl border border-zinc-800 p-4">
        <div className="space-y-1">
          <p className="text-sm font-medium text-white">Essenciais</p>
          <p className="text-xs leading-relaxed text-zinc-500">
            Necessários para autenticação, segurança e funcionamento da
            plataforma. Sempre ativos.
          </p>
        </div>
        <Switch
          checked
          disabled
          aria-label="Essenciais sempre ativos"
          data-testid="privacy-preferences-essential-switch"
        />
      </div>

      <div className="flex items-start justify-between gap-4 rounded-xl border border-zinc-800 p-4">
        <div className="space-y-1">
          <p className="text-sm font-medium text-white">Analytics</p>
          <p className="text-xs leading-relaxed text-zinc-500">
            Ajuda a entender como o FIVI360 é utilizado para melhorar a
            experiência e o produto.
          </p>
        </div>
        <Switch
          checked={analyticsEnabled}
          onCheckedChange={onAnalyticsChange}
          aria-label="Ativar analytics"
          data-testid="privacy-preferences-analytics-switch"
        />
      </div>
    </div>
  );
}
